export default "__VITE_ASSET__DY8RGQ38__"